module.exports = __webpack_public_path__ + "img/portfolio-03.993c111c.jpg";